import { cn } from '@/lib/cn';

// Projection-certainty badge, shared by the knockout bracket, match cards, and
// match detail so the treatment never drifts: a green ✓ disc when a projected
// bracket slot is 100% locked, a muted ? when it can still move. Styling lives
// in index.css (`.ko-lock`).
export function LockBadge({ locked, className }: { locked: boolean; className?: string }) {
  const label = locked ? 'Position locked' : 'Position not yet certain';
  return (
    <span
      className={cn('ko-lock', locked ? 'locked' : 'open', className)}
      title={label}
      aria-label={label}
    >
      {locked ? '✓' : '?'}
    </span>
  );
}
